import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Step } from "types";
import type { TableColumn } from "common/components/DataTable/DataTable";
import CrudList from "common/components/Crud/CrudList";
import type { CrudFilter } from "common/components/Crud/components/CrudFilters";
import { Constants } from "constants/Constants";

function Steps() {
  const { t } = useTranslation();

  const columns: TableColumn<Step>[] = useMemo(
    () => [
      {
        field: "progress",
        header: t("steps.progress"),
        sortable: true,
        renderType: "bold",
      },
      {
        field: "editLabel",
        header: t("steps.editLabel"),
        sortable: true,
      },
      {
        field: "readLabel",
        header: t("steps.readLabel"),
      },
      {
        field: "icon",
        header: t("steps.icon"),
        customRender: (rowData: Step) => {
          if (!rowData.icon?.url) return null;
          const url = rowData.icon.url.startsWith("http")
            ? rowData.icon.url
            : `${Constants.ROOT_URL}${rowData.icon.url}`;
          return (
            <img
              src={url}
              alt={rowData.editLabel}
              className="w-8 h-8 object-contain"
            />
          );
        },
      },
      {
        field: "needDate",
        header: t("steps.needDate"),
        customRender: (rowData: Step) => (
          <span>{rowData.needDate ? t("common.yes") : t("common.no")}</span>
        ),
      },
    ],
    [t]
  );

  const filters: CrudFilter[] = useMemo(
    () => [
      {
        name: "editLabel$containsi",
        label: t("steps.editLabel"),
        renderType: "input",
      },
    ],
    [t]
  );

  return (
    <CrudList
      collectionName="steps"
      columns={columns}
      filters={filters}
      defaultSort="progress:ASC"
      icon="BsListCheck"
      populate={"icon"}
      canEdit={false}
      canDelete={false}
      canSeeDetails={false}
    />
  );
}

export default Steps;
